<template>
  <div class="collect-container" @click="toggleCollect">
    <img
      :src="isCollected ? collectActIcon : collectIcon"
      class="collect-icon"
    />
    <bi-button :label="isCollected ? '取消常用' : '设为常用'" type="text" />
  </div>
</template>

<script>
import collectIcon from "@/assets/images/report/collect.svg";
import collectActIcon from "@/assets/images/report/collect_act.svg";
import { collectReport } from "@/api/bi/collect.js";

export default {
  name: "CollectCom",
  data() {
    return {
      isCollected: false,
      collectIcon,
      collectActIcon,
    };
  },
  computed: {
    screenReportMenu() {
      if (!this.$store.state.activeMenu) return {};
      return this.$store.state.menuNewList.find(
        (item) => item.path === "prefabricateReport",
      );
    },
    collectList() {
      return this.$store.state.collectList || [];
    },
    activeMenuId() {
      let id = this.$store.state.activeMenu;
      if (typeof id === "string" && id.startsWith("common_")) {
        return id.replace("common_", "");
      }
      return id;
    },
  },
  watch: {
    collectList: {
      handler(val) {
        this.checkIsCollected();
      },
      deep: true,
      immediate: true,
    },
    activeMenuId: {
      handler(val) {
        this.checkIsCollected();
      },
      immediate: true,
    },
  },
  methods: {
    checkIsCollected() {
      if (!this.activeMenuId || !this.collectList.length) {
        this.isCollected = false;
        return;
      }
      this.isCollected = this.collectList.some(
        (item) => item.reportId === this.activeMenuId,
      );
    },
    findMenuById(menus, id, path = "") {
      for (const menu of menus) {
        const currentPath = path ? `${path}/${menu.path}` : menu.path;
        if (menu.id === id) {
          return { ...menu, fullPath: currentPath };
        }
        if (menu.children && menu.children.length > 0) {
          const found = this.findMenuById(menu.children, id, currentPath);
          if (found) return found;
        }
      }
      return null;
    },
    toggleCollect() {
      // 切换状态
      const newStatus = !this.isCollected;

      const targetMenu = this.findMenuById(
        this.screenReportMenu ? [this.screenReportMenu] : [],
        this.activeMenuId,
      );

      let params = {};
      if (targetMenu) {
        params = {
          reportId: this.activeMenuId,
          isFavorite: newStatus,
          name: targetMenu.name,
          url: targetMenu.path,
          menuType: targetMenu.menuType,
          level: targetMenu.level,
        };
      }

      collectReport(params).then((res) => {
        if (res.code === 200 || res.code == 1) {
          this.$message.success(newStatus ? "已设为常用" : "已取消常用");
          // 操作成功后，刷新 Store 中的收藏列表
          this.$store.dispatch("getCollectListAction");
          this.isCollected = newStatus;
          this.$emit("change", this.isCollected);
          if (!newStatus) {
            // 在常用报表中取消
            if (String(this.$store.state.activeMenu).includes("common_")) {
              this.$router.push("/prefabricateReport/markAnalysis");
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.collect-container {
  display: flex;
  align-items: end;
  cursor: pointer;
  .collect-icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
}
</style>
